import { createContext, useContext, useState } from "react";

const SearchContext = createContext(undefined);

// Mock data
const mockCompanies = [
  { 
    id: "1", 
    name: "Acme Corp", 
    website: "acmecorp.com", 
    industry: "Technology", 
    size: "500-1000", 
    location: "San Francisco, CA",
    description: "A leading technology company specializing in AI solutions and machine learning platforms.",
    founded: "2015",
    selected: false
  },
  { 
    id: "2", 
    name: "TechGiant", 
    website: "techgiant.com", 
    industry: "Software", 
    size: "1000+", 
    location: "New York, NY",
    description: "Enterprise software solutions for businesses of all sizes with cloud infrastructure.",
    founded: "2010",
    selected: false
  },
  { 
    id: "3", 
    name: "InnovateTech", 
    website: "innovatetech.com", 
    industry: "Technology", 
    size: "100-500", 
    location: "Austin, TX",
    description: "Cutting-edge technological innovations for the modern world with IoT solutions.",
    founded: "2018",
    selected: false
  },
  {
    id: "4",
    name: "DataFlow Solutions",
    website: "dataflow.io",
    industry: "Data Analytics",
    size: "50-100",
    location: "Seattle, WA",
    description: "Advanced data analytics and business intelligence platform for enterprise clients.",
    founded: "2019",
    selected: false
  },
  {
    id: "5",
    name: "CloudVision Inc",
    website: "cloudvision.com",
    industry: "Cloud Computing",
    size: "200-500",
    location: "Denver, CO",
    description: "Multi-cloud management and optimization services for modern enterprises.",
    founded: "2016",
    selected: false
  },
  {
    id: "6",
    name: "FinTech Innovations",
    website: "fintechinno.com",
    industry: "Financial Technology",
    size: "100-200",
    location: "Chicago, IL",
    description: "Revolutionary financial technology solutions for banking and investment sectors.",
    founded: "2017",
    selected: false
  },
  {
    id: "7",
    name: "HealthTech Systems",
    website: "healthtechsys.com",
    industry: "Healthcare Technology",
    size: "300-500",
    location: "Boston, MA",
    description: "Digital healthcare solutions and telemedicine platforms for medical professionals.",
    founded: "2014",
    selected: false
  },
  {
    id: "8",
    name: "EcoSmart Energy",
    website: "ecosmartenergy.com",
    industry: "Clean Energy",
    size: "150-300",
    location: "Portland, OR",
    description: "Sustainable energy solutions and smart grid technology for residential and commercial use.",
    founded: "2020",
    selected: false
  },
  {
    id: "9",
    name: "RetailTech Pro",
    website: "retailtechpro.com",
    industry: "Retail Technology",
    size: "75-150",
    location: "Los Angeles, CA",
    description: "E-commerce platforms and retail automation solutions for modern businesses.",
    founded: "2018",
    selected: false
  },
  {
    id: "10",
    name: "CyberSecure Labs",
    website: "cybersecurelabs.com",
    industry: "Cybersecurity",
    size: "100-200",
    location: "Washington, DC",
    description: "Advanced cybersecurity solutions and threat intelligence for enterprise protection.",
    founded: "2016",
    selected: false
  }
];

const mockPeople = [
  { 
    id: "1", 
    name: "John Smith", 
    email: "john.smith@acmecorp.com", 
    jobTitle: "Chief Technology Officer", 
    company: "Acme Corp", 
    industry: "Technology", 
    location: "San Francisco, CA", 
    linkedIn: "linkedin.com/in/johnsmith-cto",
    selected: false
  },
  { 
    id: "2", 
    name: "Jane Doe", 
    email: "jane.doe@techgiant.com", 
    jobTitle: "Marketing Director", 
    company: "TechGiant", 
    industry: "Software", 
    location: "New York, NY", 
    linkedIn: "linkedin.com/in/janedoe-marketing",
    selected: false
  },
  { 
    id: "3", 
    name: "Michael Johnson", 
    email: "m.johnson@innovatetech.com", 
    jobTitle: "Chief Executive Officer", 
    company: "InnovateTech", 
    industry: "Technology", 
    location: "Austin, TX", 
    linkedIn: "linkedin.com/in/michaeljohnson-ceo",
    selected: false
  },
  {
    id: "4",
    name: "Sarah Williams",
    email: "sarah.williams@dataflow.io",
    jobTitle: "VP of Sales",
    company: "DataFlow Solutions",
    industry: "Data Analytics",
    location: "Seattle, WA",
    linkedIn: "linkedin.com/in/sarahwilliams-sales",
    selected: false
  },
  {
    id: "5",
    name: "David Chen",
    email: "david.chen@cloudvision.com",
    jobTitle: "Head of Engineering",
    company: "CloudVision Inc",
    industry: "Cloud Computing",
    location: "Denver, CO",
    linkedIn: "linkedin.com/in/davidchen-engineering",
    selected: false
  },
  {
    id: "6",
    name: "Emily Rodriguez",
    email: "emily.rodriguez@fintechinno.com",
    jobTitle: "Product Manager",
    company: "FinTech Innovations",
    industry: "Financial Technology",
    location: "Chicago, IL",
    linkedIn: "linkedin.com/in/emilyrodriguez-product",
    selected: false
  },
  {
    id: "7",
    name: "Robert Taylor",
    email: "robert.taylor@healthtechsys.com",
    jobTitle: "Chief Medical Officer",
    company: "HealthTech Systems",
    industry: "Healthcare Technology",
    location: "Boston, MA",
    linkedIn: "linkedin.com/in/roberttaylor-cmo",
    selected: false
  },
  {
    id: "8",
    name: "Lisa Anderson",
    email: "lisa.anderson@ecosmartenergy.com",
    jobTitle: "Director of Operations",
    company: "EcoSmart Energy",
    industry: "Clean Energy",
    location: "Portland, OR",
    linkedIn: "linkedin.com/in/lisaanderson-operations",
    selected: false
  },
  {
    id: "9",
    name: "James Wilson",
    email: "james.wilson@retailtechpro.com",
    jobTitle: "VP of Business Development",
    company: "RetailTech Pro",
    industry: "Retail Technology",
    location: "Los Angeles, CA",
    linkedIn: "linkedin.com/in/jameswilson-bizdev",
    selected: false
  },
  {
    id: "10",
    name: "Amanda Brown",
    email: "amanda.brown@cybersecurelabs.com",
    jobTitle: "Security Architect",
    company: "CyberSecure Labs",
    industry: "Cybersecurity",
    location: "Washington, DC",
    linkedIn: "linkedin.com/in/amandabrown-security",
    selected: false
  },
  {
    id: "11",
    name: "Kevin Martinez",
    email: "kevin.martinez@acmecorp.com",
    jobTitle: "VP of Marketing",
    company: "Acme Corp",
    industry: "Technology",
    location: "San Francisco, CA",
    linkedIn: "linkedin.com/in/kevinmartinez-marketing",
    selected: false
  },
  {
    id: "12",
    name: "Rachel Green",
    email: "rachel.green@techgiant.com",
    jobTitle: "Senior Software Engineer",
    company: "TechGiant",
    industry: "Software",
    location: "New York, NY",
    linkedIn: "linkedin.com/in/rachelgreen-engineer",
    selected: false
  },
  {
    id: "13",
    name: "Thomas Lee",
    email: "thomas.lee@innovatetech.com",
    jobTitle: "Head of Product",
    company: "InnovateTech",
    industry: "Technology",
    location: "Austin, TX",
    linkedIn: "linkedin.com/in/thomaslee-product",
    selected: false
  },
  {
    id: "14",
    name: "Jennifer Davis",
    email: "jennifer.davis@dataflow.io",
    jobTitle: "Data Scientist",
    company: "DataFlow Solutions",
    industry: "Data Analytics",
    location: "Seattle, WA",
    linkedIn: "linkedin.com/in/jenniferdavis-datascience",
    selected: false
  },
  {
    id: "15",
    name: "Mark Thompson",
    email: "mark.thompson@cloudvision.com",
    jobTitle: "Solutions Architect",
    company: "CloudVision Inc",
    industry: "Cloud Computing",
    location: "Denver, CO",
    linkedIn: "linkedin.com/in/markthompson-solutions",
    selected: false
  }
];

export function SearchProvider({ children }) {
  const [searchResults, setSearchResults] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState({
    entityType: 'people',
    industry: [],
    location: [],
    jobTitle: [],
    companySize: [],
  });

  // Helper function to preserve selections when setting new results
  const preserveSelections = (newCompanies, newPeople) => {
    if (!searchResults) {
      return {
        companies: newCompanies.map(company => ({ ...company, selected: false })),
        people: newPeople.map(person => ({ ...person, selected: false }))
      };
    }

    const existingCompanySelections = new Map(searchResults.companies.map(c => [c.id, c.selected]));
    const existingPeopleSelections = new Map(searchResults.people.map(p => [p.id, p.selected]));

    return {
      companies: newCompanies.map(company => ({
        ...company,
        selected: existingCompanySelections.get(company.id) || false
      })),
      people: newPeople.map(person => ({
        ...person,
        selected: existingPeopleSelections.get(person.id) || false
      }))
    };
  };

  // Mock search implementations
  const searchByUrl = async (url) => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setSearchResults(preserveSelections(mockCompanies, mockPeople));
    } catch (e) {
      setError('Search failed. Please try again.');
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const searchByDescription = async (description) => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setSearchResults(preserveSelections(mockCompanies, mockPeople));
    } catch (e) {
      setError('Search failed. Please try again.');
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const searchByPrompt = async (prompt) => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      setSearchResults(preserveSelections(mockCompanies, mockPeople));
    } catch (e) {
      setError('Search failed. Please try again.');
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const updateFilter = (partialFilter) => {
    setFilter(prev => ({ ...prev, ...partialFilter }));
  };

  const applyFilter = () => {
    // In a real app, this would refilter the results based on filter state
    // For the mock, we'll just simulate a refresh
    setIsLoading(true);
    
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  const toggleSelection = (id, type) => {
    if (!searchResults) return;
    
    if (type === 'people') {
      setSearchResults({
        ...searchResults,
        people: searchResults.people.map(person => 
          person.id === id ? { ...person, selected: !person.selected } : person
        )
      });
    } else {
      setSearchResults({
        ...searchResults,
        companies: searchResults.companies.map(company => 
          company.id === id ? { ...company, selected: !company.selected } : company
        )
      });
    }
  };

  const selectAll = (type) => {
    if (!searchResults) return;
    
    if (type === 'people') {
      setSearchResults({
        ...searchResults,
        people: searchResults.people.map(person => ({ ...person, selected: true }))
      });
    } else {
      setSearchResults({
        ...searchResults,
        companies: searchResults.companies.map(company => ({ ...company, selected: true }))
      });
    }
  };

  const deselectAll = (type) => {
    if (!searchResults) return;
    
    if (type === 'people') {
      setSearchResults({
        ...searchResults,
        people: searchResults.people.map(person => ({ ...person, selected: false }))
      });
    } else {
      setSearchResults({
        ...searchResults,
        companies: searchResults.companies.map(company => ({ ...company, selected: false }))
      });
    }
  };

  const getSelectedItems = () => {
    if (!searchResults) return { companies: [], people: [] };
    
    return {
      companies: searchResults.companies.filter(c => c.selected),
      people: searchResults.people.filter(p => p.selected)
    };
  };

  return (
    <SearchContext.Provider
      value={{
        searchResults,
        isLoading,
        error,
        filter,
        searchByUrl,
        searchByDescription,
        searchByPrompt,
        updateFilter,
        applyFilter,
        toggleSelection,
        selectAll,
        deselectAll,
        getSelectedItems
      }}
    >
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
}